import { gql } from "@apollo/client/core";
import { DashboardTask } from "graphql/fragments/dashboard.fragments";

export const DashboardQueries = {
  GET_MY_DASHBOARD_TASKS: gql`
    query getMyDashboardTasks {
      myDashboardTasks {
        overdueTasks {
          ...DashboardTask
        }
        myTasks {
          ...DashboardTask
        }
        groupTasks {
          ...DashboardTask
        }
        laterThisWeekTasks {
          ...DashboardTask
        }
      }
    }
    ${DashboardTask}
  `,
  GET_TASK_HISTORY: gql`
    query getTaskHistory($where: WebSuiteTaskLogFilterInput) {
      taskHistory(where: $where) {
        taskParentId
        taskId
        taskType
        actionPerformed
        actionPerformedTime
        actionPerformedBy
      }
    }
  `,
  GET_INCLUDED_FEED_PLATES: gql`
    query getIncludedFeedPlates($dateScheduled: DateTime!) {
      includedFeedPlates(dateScheduled: $dateScheduled) {
        runName
        reason
        plates {
          plateID
          plateBarcode
          activeWellCount
        }
      }
    }
  `,
  GET_EXCLUDED_FEED_PLATES: gql`
    query getExcludedFeedPlates($dateScheduled: DateTime!) {
      excludedFeedPlates(dateScheduled: $dateScheduled) {
        runName
        method
        reservationDate
        reason
        plates {
          plateID
          plateBarcode
          activeWellCount
        }
      }
    }
  `,
  GET_PLATEMAP: gql`
    query getPlateMap($plateID: Int!) {
      plateMap(plateID: $plateID) {
        plateBarcode
        arrayPlateType {
          plateLayoutType {
            plateName
          }
        }
        containers {
          containerId
          rowPos
          colPos
          isActive
        }
      }
    }
  `,
  GET_DASHBOARD_TASK: gql`
    query getDashboardTask($taskID: Int!, $taskType: TaskTypeEnum!) {
      dashboardTask(taskID: $taskID, taskType: $taskType) {
        ...DashboardTask
      }
    }
  `,
};
